import { jsxs as s, jsx as r } from "react/jsx-runtime";
import { forwardRef as f } from "react";
import e from "../builders-icons/dist/systems/info.js";
import c from "./tip.module.css.js";
import n from "clsx";
const v = f(function({ children: o, className: t, icon: i = !0, ...m }, p) {
  return /* @__PURE__ */ s("div", { ...m, className: n(c.tip, t), ref: p, children: [
    !!i && /* @__PURE__ */ r(e, {}),
    /* @__PURE__ */ r("div", { children: o })
  ] });
});
export {
  v as Tip
};
//# sourceMappingURL=tip.js.map
